
import ScheduleFilterType from "@/constants/Schedule/ScheduleFilterType";
import { i18n } from "@/i18n";

export default {
	// flags
	/**
	 * @note The Schedule.vue component is responsible for
	 * setting this flag back to true, after a scroll attempt.
	 * The store should only ever set it to false.
	 */
	isEnabled: true,
	isRefreshingSchedule: true,
	/** TODO: topics are a meeting agenda store concern - move */
	isRequestingTopics: false,
	/** TODO: topics are a meeting agenda store concern - move */
	isResortingTopics: false,
	/** TODO: topics are a meeting agenda store concern - move */
	isSavingTopics: false,
	isBackgroundUpdate: false,
	isRefreshAllowed: true, // Will need to be set to false when adding topics, etc.
	isBackgroundRefreshWaiting: false, // set to true when isRefreshAllowed is false and updateInBackground is dispatched
	/** TODO: topics are a meeting agenda store concern - move */
	isRemovingTopics: false,
	isScheduleSyncing: false,
	hasScheduleSyncFailed: false,
	isAssigningTeam: false,
	/** TODO: commitments are a meeting agenda store concern - move */
	isFetchingMeetingCommitments: false,
	/** TODO: commitments are a meeting agenda store concern - move */
	isChangingCommitmentCompletion: false,
	isFetchingMeetingSeries: false,
	isFetchingTeamGoals: false,
	isConnectingTeam: false,
	isOverviewVideoModalOpen: false,

	// maps
	offsetMeetingMap: {},
	dateMeetingMap: {},

	/** TODO: topics are a meeting agenda store concern - move */
	meetingTopicMap: {}, // NOTE: use meetingTopicMap for topic manipulation; do NOT rely on meeting.topics
	/** TODO: topics are a meeting agenda store concern - move */
	meetingTopicRequestMap: {},
	/** TODO: remove once topic fields are fully implemented in meeting agenda store, as they will compute dirty state */
	dirtyTopicFlagMap: {},

	/**
	 * @type {Object.<meetingSeriesId, Object<meetingId, meeting>>}
	 */
	meetingSeriesMap: {},
	meetingSeriesOffsetMap: {},
	meetingPermissionsMap: {},
	topicPermissionsMap: {},
	/** TODO: topics are a meeting agenda store concern - move */
	topicDeferralMap: {},
	meetingInviteeMap: {},

	/** TODO: outcomes are a meeting agenda store concern - move */
	outcomeMap: {},
	/** TODO: outcomes are a meeting agenda store concern - move */
	meetingOutcomeIdMap: {},

	// state
	meetings: {},
	scheduleFilterOptions: [
		{
			text: i18n.t( "scheduleStore.store_filterOption_allMeetings" ),
			value: ScheduleFilterType.ALL_MEETINGS,
			icon: [ "fas", "calendar-alt", ],
		},
		{
			text: i18n.t( "scheduleStore.store_filterOption_teamMeetings" ),
			value: ScheduleFilterType.TEAM_MEETINGS,
			icon: [ "fas", "users", ],
		},
		{
			text: i18n.t( "scheduleStore.store_filterOption_oneOnOneMeetings" ),
			value: ScheduleFilterType.ONE_ON_ONE_MEETINGS,
			icon: [ "fas", "people-arrows", ],
		},
		{
			text: i18n.t( "scheduleStore.store_filterOption_noTopicMeetings" ),
			value: ScheduleFilterType.MEETINGS_WITH_NO_TOPICS,
			icon: [ "fas", "exclamation-triangle", ],
		},
		{
			text: i18n.t( "scheduleStore.store_filterOption_noTeamMeetings" ),
			value: ScheduleFilterType.MEETINGS_WITH_NO_TEAM,
			icon: [ "fas", "users-slash", ],
		},
	],
	selectedFilterOption: ScheduleFilterType.ALL_MEETINGS,
	persistableFilterOptions: [
		{
			text: i18n.t( "scheduleStore.store_persistableFilterOption_showAllDay" ),
			id: "showAllDayEvents",
		},
		{
			text: i18n.t( "scheduleStore.store_persistableFilterOption_showOnlyMe" ),
			id: "showEventsWithOnlyMe",
		},
		{
			text: i18n.t( "scheduleStore.store_persistableFilterOption_showHidden" ),
			id: "showHiddenMeetings",
		},
	],
	selectedScheduleDate: null,
	selectedScheduleMeetingId: "",
	selectedWeekOffset: 0,
	/** TODO: selected tab is a meeting store concern - move */
	selectedMeetingTab: "",
	/**
	 * @type Number[]
	 */
	invalidatedOffsets: [],
	keyResultFetchErrors: {},
	newTopic: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/schedule/state.js